import { axiosGet, axiosPost } from "../../react_axios/Axios"
import { getAccountReceiptListUrl, GET_ACCOUNT_RECEIPT_LIST, getPerformaInvoiceReceiptListUrl, GET_PERFORMA_INVOICE_RECEIPT_LIST, ACCOUNT_RECEIPT_GENERATE_INVOICE, accountReceiptGenerateInvoiceUrl, ADD_ACCOUNT_RECEIPT_LIST, addAccountReceiptListUrl, UPDATE_ACCOUNT_RECEIPT_LIST, updateAccountReceiptListUrl, getAccountReceiptDetailsUrl, GET_ACCOUNT_RECEIPT_DETAILS, deleteAccountReceiptListUrl, DELETE_ACCOUNT_RECEIPT_LIST, fetchReport, DOWNLOAD_PERFORMA_INVOICE, performaInvoice, GET_RECEIPT_NO_ACTION_TYPE, getReceiptNoUrl, headers, ReceiptUpdateNoDueUrl, ReceiptUpdateTaxInvoiceUrl, RECEIPT_NO_DUE_ACTION_TYPE, RECEIPT_TAX_INVOICE_ACTION_TYPE, getSendMailReceiptDetailsUrl, GET_SEND_MAIL_RECEIPT_DETAILS_ACTION_TYPE,SEND_TAX_INVOICE_ACTION_TYPE,sendTaxInvoiceUrl, PREVIEW_RECEIPT_ACTION_TYPE, previewRecieptUrl } from "../../utils/constants"
import moment from 'moment';

export const accountReceipt_list_action = (client, receiptFromDate, receiptToDate, receiptNo) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('userId') != '' ? sessionStorage.getItem('userId') : null,
            Client: client != '' && client != 'null' ? client : null,
            ReceiptFromDate: receiptFromDate != null && receiptFromDate != 'null' ? receiptFromDate : null,
            ReceiptToDate: receiptToDate != null && receiptToDate != 'null' ? receiptToDate : null,
            ReceiptNo: receiptNo != '' && receiptNo != 'null' ? receiptNo : null,
        };

        const res = await axiosGet(getAccountReceiptListUrl, mapdata, headers);
        dispatch({
            type: GET_ACCOUNT_RECEIPT_LIST,
            payload: res,
        });
        return res; // No need to wrap in Promise.resolve()
    } catch (err) {
        return Promise.reject(err);
    }
};

export const delete_accountReceipt_list_action = (userId, receiptID) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: userId != '' ? userId : null,
            ReceiptID: receiptID != '' ? receiptID : null,
        };

        const res = await axiosGet(deleteAccountReceiptListUrl, mapdata, headers);
        dispatch({
            type: DELETE_ACCOUNT_RECEIPT_LIST,
            payload: res,
        });
        return res; // No need to wrap in Promise.resolve()
    } catch (err) {
        return Promise.reject(err);
    }
};

export const accountReceipt_Details_action = (userId, clientID, receiptID) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: userId != '' ? userId : sessionStorage.getItem('userId'),
            ClientID: clientID != '' ? clientID : null,
            ReceiptID: receiptID != '' ? receiptID : null,
            Token: null,
        };

        console.log("accountReceipt_Details_action mapdata...", mapdata);
        const res = await axiosGet(getAccountReceiptDetailsUrl, mapdata, headers);
        dispatch({
            type: GET_ACCOUNT_RECEIPT_DETAILS,
            payload: res,
        });
        return res; // No need to wrap in Promise.resolve()
    } catch (err) {
        return Promise.reject(err);
    }
};


export const getPerformaInvoiceReceiptList_list_action = (clientID, ReceivedAmount, OrderID, ReceiptDetailID) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('userId') != '' ? sessionStorage.getItem('userId') : null,
            ClientID: clientID != '' ? clientID : null,
            ReceivedAmount: ReceivedAmount != '' ? ReceivedAmount : null,
            OrderID: OrderID != '' ? OrderID : null,
            ReceiptDetailID: ReceiptDetailID != '' ? ReceiptDetailID : null,
        };

        console.log("accountReciept mapdata...", mapdata);
        const res = await axiosGet(getPerformaInvoiceReceiptListUrl, mapdata, headers);
        dispatch({
            type: GET_PERFORMA_INVOICE_RECEIPT_LIST,
            payload: res,
        });
        return res; // No need to wrap in Promise.resolve()
    } catch (err) {
        return Promise.reject(err);
    }
};

export const generate_invoice_action = (clientId, BankAccountId, currencyID, conRate, bankAmount, TDSAmount, exchDiff, onAccAmt, crAmount, totalAmount, performaList, otherChargesList, ReceiptID) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('userId') != '' ? sessionStorage.getItem('userId') : null,
            ClientId: clientId != '' ? clientId : null,
            BankAccountId: BankAccountId != '' ? BankAccountId : null,
            CurrencyID: currencyID != '' ? currencyID : null,
            ConRate: conRate != '' ? parseInt(conRate) : null,
            BankAmount: bankAmount != '' ? parseInt(bankAmount) : null,
            TDSAmount: TDSAmount != '' ? parseInt(TDSAmount) : null,
            ExchDiff: exchDiff != '' ? parseInt(exchDiff) : null,
            onAccAmt: onAccAmt,
            CrAmount: crAmount,
            TotalAmount: totalAmount != '' ? parseInt(totalAmount) : null,
            PerformaList: performaList != '' ? performaList : null,
            OtherChargesList: otherChargesList != '' ? otherChargesList : null,
            ReceiptID: ReceiptID != '' && ReceiptID != null ? ReceiptID : 0,
        };

        console.log("accountReciept mapdata...", mapdata);
        const res = await axiosPost(accountReceiptGenerateInvoiceUrl, mapdata, headers);
        dispatch({
            type: ACCOUNT_RECEIPT_GENERATE_INVOICE,
            payload: res,
        });
        return res; // No need to wrap in Promise.resolve()
    } catch (err) {
        return Promise.reject(err);
    }
};


export const addAccountReceipt_list_action = (voucherTypeID, clientID, bankID, currencyID, conversionRate, bankAmount, TDSAmount, exchangeDifference, onAccAmount, creditAmount, totalAmount, receiptNo, receiptDate, paymentModeID, paymentReceivedDate, instrumentNo, instrumentDate, bankName, branchName, narration, performaList, otherChargesList, LedgerList, orderNo) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('userId'),
            Token: null,
            VoucherTypeID: voucherTypeID != '' ? voucherTypeID : null,
            ClientID: clientID != '' ? clientID : null,
            BankID: bankID != '' ? bankID : null,
            CurrencyID: currencyID != '' ? currencyID : null,
            ConversionRate: conversionRate != '' ? conversionRate : null,
            BankAmount: bankAmount != '' ? parseFloat(bankAmount) : null,
            TDSAmount: TDSAmount != '' ? parseFloat(TDSAmount) : null,
            ExchangeDifference: exchangeDifference != '' ? exchangeDifference : null,
            OnAccAmount: onAccAmount != '' ? onAccAmount : 0,
            CreditAmount: creditAmount != '' ? creditAmount : 0,
            TotalAmount: totalAmount != '' ? parseFloat(totalAmount) : null,
            ReceiptNo: receiptNo != '' ? receiptNo : null,
            ReceiptDate: receiptDate != '' ? receiptDate : null,
            PaymentModeID: paymentModeID != '' ? paymentModeID : null,
            PaymentReceivedDate: paymentReceivedDate != '' ? paymentReceivedDate : null,
            InstrumentNo: instrumentNo != '' ? instrumentNo : null,
            InstrumentDate: instrumentDate != '' ? moment(instrumentDate).format('YYYY-MM-DD') : null,
            BankName: bankName != '' ? bankName : null,
            BranchName: branchName != '' ? branchName : null,
            Narration: narration != '' ? narration : null,
            PerformaList: performaList != '' ? performaList : null,
            OtherChargesList: otherChargesList != '' ? otherChargesList : null,
            LedgerList: LedgerList != '' ? LedgerList : null,
            OrderNo: orderNo,
            isOnline: 0,
        };

        console.log("addAccountReceiptListUrl mapdata...", mapdata);
        const res = await axiosPost(addAccountReceiptListUrl, mapdata, headers);
        dispatch({
            type: ADD_ACCOUNT_RECEIPT_LIST,
            payload: res,
        });
        return res; // No need to wrap in Promise.resolve()
    } catch (err) {
        return Promise.reject(err);
    }
};

export const updateAccountReceipt_list_action = (userId, ReceiptID, voucherTypeID, clientID, bankID, currencyID, conversionRate, bankAmount, TDSAmount, exchangeDifference, onAccAmount, creditAmount, totalAmount, receiptNo, receiptDate, paymentModeID, paymentReceivedDate, instrumentNo, instrumentDate, bankName, branchName, narration, performaList, otherChargesList, LedgerList, orderNo) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('userId'),
            Token: null,
            ReceiptID: ReceiptID != '' ? ReceiptID : null,
            VoucherTypeID: voucherTypeID != '' ? voucherTypeID : null,
            ClientID: clientID != '' ? clientID : null,
            BankID: bankID != '' ? bankID : null,
            CurrencyID: currencyID != '' ? currencyID : null,
            ConversionRate: conversionRate != '' ? conversionRate : null,
            BankAmount: bankAmount != '' ? bankAmount : null,
            TDSAmount: TDSAmount != '' ? TDSAmount : null,
            ExchangeDifference: exchangeDifference != '' ? parseInt(exchangeDifference) : 0,
            OnAccAmount: onAccAmount != '' ? onAccAmount : 0,
            CreditAmount: creditAmount != '' ? creditAmount : 0,
            TotalAmount: totalAmount != '' ? totalAmount : null,
            ReceiptNo: receiptNo != '' ? receiptNo : null,
            ReceiptDate: receiptDate != '' ? receiptDate : null,
            PaymentModeID: paymentModeID != '' ? paymentModeID : null,
            PaymentReceivedDate: paymentReceivedDate != '' ? paymentReceivedDate : null,
            InstrumentNo: instrumentNo != '' ? instrumentNo : null,
            InstrumentDate: instrumentDate != '' ? moment(instrumentDate).format('YYYY-MM-DD') : null,
            BankName: bankName != '' ? bankName : null,
            BranchName: branchName != '' ? branchName : null,
            Narration: narration != '' ? narration : null,
            PerformaList: performaList != '' ? performaList : null,
            OtherChargesList: otherChargesList != '' ? otherChargesList : null,
            LedgerList: LedgerList,
            OrderNo: orderNo,
            isOnline: 0,
        };

        console.log("updateAccountReceiptListUrl mapdata...", mapdata);
        const res = await axiosPost(updateAccountReceiptListUrl, mapdata, headers);
        dispatch({
            type: UPDATE_ACCOUNT_RECEIPT_LIST,
            payload: res,
        });
        return res; // No need to wrap in Promise.resolve()
    } catch (err) {
        return Promise.reject(err);
    }
};

export const download_account_receipt_action = (userId, receiptID, receiptNo) => async (dispatch) => {
    try {
        var list = [];
        const mapdata = {
            "ParameterName": "@ReceiptID",
            "ParameterValue": receiptID,
            "ParameterDataType": "int"
        }
        list.push(mapdata);
        const mapData = {
            "user_id": userId,
            "report_name": "ManualReceiptVoucher.rpt",
            "report_file_name": receiptNo,
            "config_id": 0,
            "parameter_details": list,

        }
        console.log(mapData)
        const res = await axiosPost(fetchReport, mapData, headers);

        dispatch({
            type: DOWNLOAD_PERFORMA_INVOICE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getReceiptNo_list_action = (clientID) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('userId') != '' ? sessionStorage.getItem('userId') : null,
            ClientID: clientID != '' ? clientID : null,
        };
        const res = await axiosGet(getReceiptNoUrl, mapdata, headers);
        dispatch({
            type: GET_RECEIPT_NO_ACTION_TYPE,
            payload: res,
        });
        return res; // No need to wrap in Promise.resolve()
    } catch (err) {
        return Promise.reject(err);
    }
};

export const generate_nodue_action =
    (OrderID, OrderNo, CompanyName, PrimaryEmailID, ProformaInvoiceID, ProformaInvoice_No) => async (dispatch) => {
        try {
            const mapdata = {
                userId:
                    sessionStorage.getItem("userId") == "" ||
                        sessionStorage.getItem("userId") == null
                        ? ""
                        : sessionStorage.getItem("userId"),
                OrderID: OrderID,
                OrderNo: OrderNo,
                username: CompanyName,
                email: PrimaryEmailID ? PrimaryEmailID.toString().trim() : "",
                ProformaInvoiceID: ProformaInvoiceID, ProformaInvoice_No: ProformaInvoice_No
            };
            console.log("generate noDue mapdata...", mapdata);
            const res = await axiosPost(ReceiptUpdateNoDueUrl, mapdata, headers);
            dispatch({
                type: RECEIPT_NO_DUE_ACTION_TYPE,
                payload: res,
            });
            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err);
        }
    };

export const generate_taxInvoice_action =
    (OrderID, OrderNo, CompanyName, PrimaryEmailID, ProformaInvoiceID, ProformaInvoice_No) => async (dispatch) => {
        try {
            const mapdata = {
                userId:
                    sessionStorage.getItem("userId") == "" ||
                        sessionStorage.getItem("userId") == null
                        ? ""
                        : sessionStorage.getItem("userId"),
                OrderID: OrderID,
                OrderNo: OrderNo,
                username: CompanyName,
                email: PrimaryEmailID ? PrimaryEmailID.toString().trim() : "",
                ProformaInvoiceID: ProformaInvoiceID, ProformaInvoice_No: ProformaInvoice_No
            };
            console.log("generate noDue mapdata...", mapdata);
            const res = await axiosPost(ReceiptUpdateTaxInvoiceUrl, mapdata, headers);
            dispatch({
                type: RECEIPT_TAX_INVOICE_ACTION_TYPE,
                payload: res,
            });
            return Promise.resolve(res);
        } catch (err) {
            return Promise.reject(err);
        }
    };

export const getSendMailReceiptDetailsUrl_action = (ReceiptID, OrderNo, BankAmount, TDSAmount) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: sessionStorage.getItem('userId'),
            ReceiptID: ReceiptID,
            OrderNo: OrderNo,
            BankAmount: BankAmount,
            TDSAmount: TDSAmount,
            isOnline: 0,
        };

        console.log("getSendMailReceiptDetailsUrl mapdata...", mapdata);
        const res = await axiosGet(getSendMailReceiptDetailsUrl, mapdata, headers);
        dispatch({
            type: GET_SEND_MAIL_RECEIPT_DETAILS_ACTION_TYPE,
            payload: res,
        });
        return res; // No need to wrap in Promise.resolve()
    } catch (err) {
        return Promise.reject(err);
    }
};

export const send_tax_invoice_action = (OrderNo, OrderID, companyName, primaryEmailID, ProformaInvoiceID, ProformaInvoice_No, SecurityEmailData) => async (dispatch) => {
    try {
        const mapdata = {
            userId: parseInt(sessionStorage.getItem('userId')),
            OrderNo: OrderNo,
            OrderID: OrderID,
            companyName: companyName,
            primaryEmailID: primaryEmailID,
            ProformaInvoiceID: ProformaInvoiceID,
            ProformaInvoice_No: ProformaInvoice_No,
            SecurityEmailData: SecurityEmailData,
        }
        const res = await axiosPost(sendTaxInvoiceUrl, mapdata, headers);

        dispatch({
            type: SEND_TAX_INVOICE_ACTION_TYPE,
            payload: res,
        });
        // console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const preview_receipt_action = (ReceiptID,ReceiptNo) => async (dispatch) => {
    try {
    console.log('con 3')

        const mapdata = {
            userId: parseInt(sessionStorage.getItem('userId')),
            ReceiptID:ReceiptID,ReceiptNo:ReceiptNo
        }
        const res = await axiosPost(previewRecieptUrl, mapdata, headers);

        dispatch({
            type: PREVIEW_RECEIPT_ACTION_TYPE,
            payload: res,
        });
        // console.log(res)

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};